import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISystemActionCategory } from 'src/app/domain/registration/models/ISystemActionCategory';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { SystemActionCategoryCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { SystemActionCategoryService } from '../crud-service';

@Component({
  selector: 'app-system-action-category-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemActionCategoryService],
})
export class SystemActionCategoryCrudIndex
  extends AbstractCrudIndex<ISystemActionCategory>
  implements ITableResponsive
{
  override title = 'CATEGORIA DE AÇÕES DO SISTEMA';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  constructor(
    public override dialog: MatDialog,
    public override service: SystemActionCategoryService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  // loadList() {
  //   let params = this.params;

  //   this.service.listAll(params).subscribe((dataWithPagination: any) => {
  //     const [data, length] = dataWithPagination;
  //     this.length = length;

  //     this.dataSource = new MatTableDataSource<any>(
  //       data.map((item: any) => {
  //         item['hideEdit'] = !item.allowEdit;
  //         item['hideDelete'] = !item.allowDelete;
  //         return item;
  //       })
  //     );
  //   });
  // }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemActionCategoryCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemActionCategoryCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      callBack: (data: any) => {
        if (data?.element) {
          let { name } = data.element;
          let object: ISystemActionCategory = {
            name: name?.toUpperCase(),
          };

          this.service.create(Object.assign({}, object)).subscribe(
            () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
            },
            (error) => {
              this.openNew(data.element);
            }
          );
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: SystemActionCategoryCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      callBack: (data: any) => {
        if (data?.element?.id) {
          let { id, name, description } = data.element;
          let object: ISystemActionCategory = {
            name: name?.toUpperCase(),
          };

          this.service.update(id, Object.assign({}, object)).subscribe({
            next: () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
            },
            error: (error) => {
              this.openNew(data.element);
            },
          });
        }

        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  // openDelete(element: any) {
  //   GlobalUtils.openDialog({
  //     dialog: this.dialog,
  //     data: { title: 'REMOÇÃO' },
  //     component: DialogConfirmComponent,
  //     callBack: (data: any) => {
  //       if (data?.result) {
  //         this.delete(element);
  //       }
  //     },
  //   });
  // }

  // delete(element: any) {
  //   this.service.delete(element.id).subscribe(() => {
  //     this.loadList();
  //     this.toastService.showSuccess(MessagesEnum.SUCCESS_DELETED);
  //   });
  // }

  // changePage(event: any) {
  //   this.params.page = event.page;
  //   this.params.limit = event.limit;
  //   this.loadList();
  // }

  // filter(event: any) {
  //   this.params.filter = event;
  //   this.loadList();
  // }

  // filterFields: IFieldConfig[];

  // submitAdvancedFilter($event: any) {
  //   throw new Error('Method not implemented.');
  // }
}
